/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Past_Sets_EmptyInputs */

const en_us2_workout_past_sets_empty = /** @type {(inputs: Workout_Past_Sets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sets were logged in this workout.`)
};

const pt_br2_workout_past_sets_empty = /** @type {(inputs: Workout_Past_Sets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma série registrada neste treino.`)
};

const es_419_workout_past_sets_empty = /** @type {(inputs: Workout_Past_Sets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se registraron series en este entrenamiento.`)
};

const pt_pt2_workout_past_sets_empty = /** @type {(inputs: Workout_Past_Sets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma série registada neste treino.`)
};

const fr_fr2_workout_past_sets_empty = /** @type {(inputs: Workout_Past_Sets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune série n'a été enregistrée dans cette séance.`)
};

const de_de2_workout_past_sets_empty = /** @type {(inputs: Workout_Past_Sets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In diesem Training wurden keine Sätze erfasst.`)
};

const it_it2_workout_past_sets_empty = /** @type {(inputs: Workout_Past_Sets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In questo allenamento non è stata registrata nessuna serie.`)
};

/**
* | output |
* | --- |
* | "No sets were logged in this workout." |
*
* @param {Workout_Past_Sets_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_past_sets_empty = /** @type {((inputs?: Workout_Past_Sets_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Past_Sets_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_past_sets_empty(inputs)
	if (locale === "es-419") return es_419_workout_past_sets_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_past_sets_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_past_sets_empty(inputs)
	if (locale === "de-DE") return de_de2_workout_past_sets_empty(inputs)
	if (locale === "it-IT") return it_it2_workout_past_sets_empty(inputs)
	return en_us2_workout_past_sets_empty(inputs)
});
export { workout_past_sets_empty as "workout.past_sets_empty" }